<template>
  <v-card class="mb-5">
    <v-card-title class="primary white--text">Noticeboard</v-card-title>
    <v-card class="pa-4" flat>
      <v-card dark class="light-blue pa-5">
        <div class="headline">Hi {{ user.name }},</div>
        <div>{{ company.name }}</div>
      </v-card>
      <v-card class="pa-2 grey lighten-5" style="display:flex">
        <v-avatar class="profile" color="grey" size="164" tile>
          <v-img
            src="https://i2-prod.hulldailymail.co.uk/incoming/article2632504.ece/ALTERNATES/s615b/0_PW_HM_110319SUREGROUP.jpg"
          ></v-img>
        </v-avatar>
        <div
          class="px-4 pt-4"
          style="text-align:right;flex-grow:1;display:flex;flex-direction:column;justify-content:space-between;align-items:flex-end"
        >
          <div>
            This month we are looking to increase our capacity in the driving
            and health care sectors. As we get closer to christmas, I am
            confident we can achieve our end of year targets
          </div>
          <br />
          <div>
            in 2020, we will mainly be looking to focus on expanding our offices
            into the north of england
          </div>
          <div class="font-weight-bold">Charles Draper, Managing Director</div>
        </div>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    user() {
      return this.account.user;
    },
    company() {
      return this.account.company;
    }
  }
};
</script>
